import { GameEvent, GameState } from '../shared/state'
import { tick } from '../shared/sim'
import { PlayerInput } from '../shared/types'

// Boucle requestAnimationFrame + accumulateur à pas de temps FIXE : la simulation
// avance exactement à 30 Hz quelle que soit la cadence d'affichage, et le rendu
// interpole entre l'état précédent et l'état courant (fluide au-delà de 30 fps).
export const MS_PER_TICK = 1000 / 30

export interface LoopHandle { stop(): void }
export interface LoopOpts {
  state: GameState
  input: () => PlayerInput
  onTick?: (events: GameEvent[]) => void
  draw: (prev: GameState | null, cur: GameState, alpha: number) => void
  // Départ « speed-run » (#1) : tant que `running` renvoie faux, la sim est GELÉE (aucun tick) et le
  // temps réel écoulé est JETÉ. Absent -> toujours actif (contrat historique : l'online n'y touche pas).
  running?: () => boolean
}

// Pur : combien de sous-pas exécuter et quel `acc` résiduel, selon le temps accumulé et l'état gelé.
// GELÉ (running=false) : zéro pas ET acc remis à 0 — le temps passé figé ne se rejoue JAMAIS au
// dégel. Sans ça, un niveau gelé 10 s cracherait une rafale de ticks au premier ordre du joueur
// (chrono qui saute, moines qui se téléportent). ACTIF : pas de MS_PER_TICK, plafonné à 5 (anti-spirale).
export function planTicks(acc: number, running: boolean): { steps: number; acc: number } {
  if (!running) return { steps: 0, acc: 0 }
  let steps = 0
  while (acc >= MS_PER_TICK && steps < 5) { acc -= MS_PER_TICK; steps++ }
  return { steps, acc }
}

export function startLoop(opts: LoopOpts): LoopHandle {
  let prev: GameState | null = null
  let acc = 0
  let last = performance.now()
  let raf = 0
  let stopped = false
  const frame = (now: number) => {
    if (stopped) return
    acc += Math.min(now - last, 250) // clamp anti-« spirale de la mort » après un onglet en veille
    last = now
    const plan = planTicks(acc, opts.running ? opts.running() : true)
    acc = plan.acc
    for (let i = 0; i < plan.steps; i++) {
      prev = structuredClone(opts.state) // snapshot AVANT le tick (interpolation). Copie native (dont l'Uint8Array du terrain), sans l'aller-retour JSON coûteux sur mobile.
      const ev = tick(opts.state, [opts.input()])
      opts.onTick?.(ev)
    }
    opts.draw(prev, opts.state, Math.min(1, acc / MS_PER_TICK))
    raf = requestAnimationFrame(frame)
  }
  raf = requestAnimationFrame(frame)
  return { stop() { stopped = true; cancelAnimationFrame(raf) } }
}
